AoPS.Utils.initKeyChain(AoPS, "Contests", "Views");

AoPS.Contests.Views = (function (Views) {
	Views.ContestSpecialRegisterMain = AoPS.View.extend({
		template_id: "#contest-special-register-main-tpl",
		className: "contest-special-register-main",
		initialize: function (options) {
			this.render();
		},
		constructCrumbs: function () {
			return [
				{
					text:
						this.model.get("contest_crumb_name") ||
						this.model.get("contest_name"),
				},
			];
		},
		render: function () {
			this.vars = this.model.export();
			this.$el.html(this.model.getCmsTemplate(this.template_id, this.vars));

			this.$description_inner = this.$(".description-inner");
			this.$registration_inner = this.$(".registration-inner");

			if (this.vars.requested_user) {
				this.renderRegistered();
			} else {
				this.renderDescription();
				if (
					!this.vars.user_type_is_coach ||
					!this.vars.supervisor_registration_has_ended
				) {
					this.renderRegistration();
				}
			}

			if (AoPS.session.logged_in && !AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
			}
		},
		renderRegistered: function () {
			var view = new Views.ContestSpecialRegisterRegistered({
				model: this.model,
				parent: this,
				root: this,
			});
			view.$el.appendTo(this.$description_inner);
		},
		renderDescription: function () {
			var view = new Views.ContestSpecialRegisterDescription({
				model: this.model,
				parent: this,
				root: this,
			});
			view.$el.appendTo(this.$description_inner);
		},
		renderRegistration: function () {
			var view = new Views.ContestSpecialRegisterRegistration({
				model: this.model,
				parent: this,
				root: this,
			});
			view.$el.appendTo(this.$registration_inner);
		},
	});

	Views.ContestSpecialRegisterRegistered = AoPS.View.extend({
		template_id: "#contest-special-register-registered-tpl",
		initialize: function (options) {
			this.parent = options.parent;
			this.root = options.root;
			this.render();
		},
		render: function () {
			this.vars = _.extend({}, this.parent.vars);
			this.$el.html(this.model.getCmsTemplate(this.template_id, this.vars));
		},
	});

	Views.ContestSpecialRegisterDescription = AoPS.View.extend({
		template_id: "#contest-special-register-description-tpl",
		initialize: function (options) {
			this.parent = options.parent;
			this.root = options.root;
			this.render();
		},
		render: function () {
			this.vars = _.extend({}, this.parent.vars);
			this.$el.html(this.model.getCmsTemplate(this.template_id, this.vars));
		},
		events: {
			"click .sign-in": "showSignInModal",
		},
		showSignInModal: function () {
			AoPS.login.display();
		},
	});

	Views.ContestSpecialRegisterRegistration = AoPS.View.extend({
		template_id: "#contest-special-register-registration-tpl",
		initialize: function (options) {
			this.parent = options.parent;
			this.root = options.root;
			this.portal_host_id = null;
			this.render();
		},
		render: function () {
			this.vars = _.extend({}, this.parent.vars);

			this.$el.html(this.model.getCmsTemplate(this.template_id, this.vars));
			this.renderSchoolNameAutocomplete();
		},
		renderSchoolNameAutocomplete: function () {
			this.$school_name = this.$("form input[name='school_name']");
			this.$school_name.aopsAutocomplete({
				source: this.model
					.get("master")
					.get("contest_portal_hosts")
					.models.map(function (model) {
						var name = model.get("name");
						return {value: name, label: name};
					}),
				minLength: 0,
			});
		},
		events: {
			"click .redirect-create-account": "redirectCreateAccount",
			"click .sign-out": "signOut",
			"submit form": "submitRegistration",
		},
		redirectCreateAccount: function () {
			AoPS.login.register();
		},
		signOut: function (e) {
			AoPS.login.logout(e);
		},
		submitRegistration: function (e) {
			e.preventDefault();

			if (AoPS.session.logged_in && !AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
				return;
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
				return;
			}

			var formData = _.reduce(
				this.$("form").serializeArray(),
				function (object, item) {
					object[item.name] = item.value;
					return object;
				},
				{}
			);
			var issues = [];

			if (!AoPS.session.logged_in) {
				if (
					!formData.email.match(
						/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					)
				) {
					issues.push("You must enter a valid email.");
				}

				// Note: We suspended the institutional email requirement because of T52556
				/*
				if (this.vars.user_type_is_coach) {
					if (!formData.email.match(/(\.edu|\.ca)$/i)) {
						issues.push(
							"You must enter an institutional email ending with .edu or .ca for Putnam Supervisor Registration."
						);
					}
				}
				*/

				if (!formData.username.match(/^[a-z\_0-9]{4,25}$/i)) {
					issues.push("Please enter a valid username.");
				}

				if (!formData.password.match(/^[^\s]{5,}$/)) {
					issues.push("Please enter a valid password.");
				} else if (formData.password !== formData.repassword) {
					issues.push("Passwords do not match.");
				}
			}

			if (this.vars.user_type_is_coach) {
				// Coach only checks
				if (!formData.school_name) {
					issues.push("Please enter an Institution Name.");
				}

				if (!formData.school_website) {
					issues.push(
						"Please enter an Institution Website where you are listed as a faculty member."
					);
				}
			} else {
				// Student only checks
				if (!formData.first_name) {
					issues.push("Please enter a First Name.");
				}

				if (!formData.last_name) {
					issues.push("Please enter a Last Name.");
				}

				if (formData.middle_initial && formData.middle_initial.length > 2) {
					issues.push(
						"Please enter at most two characters for Middle Initial."
					);
				}

				var contest_portal_hosts = this.model
					.get("master")
					.get("contest_portal_hosts").models;
				if (
					!_.some(contest_portal_hosts, function (host) {
						return formData.school_name === host.get("name");
					})
				) {
					issues.push(
						"Please select an Institution from the list of approved institutions."
					);
				}
			}

			if (!formData.accept) {
				issues.push("Please agree to the terms.");
			}

			if (issues.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Please fix the following issue" +
								(issues.length > 1 ? "s" : "") +
								" before " +
								(AoPS.session.logged_in
									? "registering for this competition:"
									: "creating a new account:")
						)
						.append(
							_.reduce(
								issues,
								_.bind(function ($ul, issue) {
									return $ul.append($("<li />").text(issue));
								}, this),
								$("<ul />")
							)
						)
				);
				return;
			} else {
				AoPS.Contests.Utils.CreateModalConfirm(
					$("<div />")
						.css("max-width", "480px")
						.html(
							this.model.getCmsTemplate(
								"#contest-special-register-registration-modal-" +
									(AoPS.session.logged_in ? "register" : "create") +
									"-account-tpl",
								_.extend({formData: formData}, this.vars)
							)
						),
					_.bind(function () {
						this.model.submitRegistration(
							formData,
							_.bind(function () {
								if (AoPS.session.logged_in) {
									this.root.render();
								} else {
									window.location.reload();
								}
							}, this)
						);
					}, this)
				);
			}
		},
	});

	return Views;
})(AoPS.Contests.Views || {});
